<template>
  <header class="header">
    <div 
      class="mini-header bg-black py-2 headerFixed"
      :style="$route.name != 'home' ? 'height: 65px;' : ''">
      <div class="container itemDisplayMobile">
        <b-row>
          <b-col cols="12" class="text-center">
            <img class="img-fluid-mobile" src="@/assets/img/new-logo.png" alt="Logo Constr Up">
          </b-col>
        </b-row>
      </div>

      <div class="container itemDisplay">
        <b-row v-if="!checkIsEmpty(token) && !checkIsEmpty(dadosUsuario)">          
          <b-col cols="12" class="info-right mt-2">
            <p class="mb-0 c-white">
              <span> Bem-vindo(a) {{ dadosUsuario.nome_usuario }} </span>
            </p>

            <span class="text-white c-pointer ml-4 mr-4" title="Sair da sua conta">
              <router-link class="text-white fs-22" :to="{ name: 'sair' }">
                <i class="fas fa-power-off c-orange-hover"></i>
              </router-link>
            </span>

            <b-button
              v-if="$route.name === 'home'"
              class="bg-orange text-white pl-3 pr-3 zoom-on-hover"
              @click="goToPages()"
              pill
              variant="warning"
            >
              Meu painel
            </b-button>
          </b-col>
        </b-row>

        <b-row class="d-flex justify-content-center align-items-center" v-if="$route.name == 'home'">
          <b-col cols="4">
            <img class="img-fluid" src="@/assets/img/new-logo.png" alt="Logo Constr Up" width="300">
          </b-col>
          <b-col cols="8" class="text-right">
            <span 
              class="btn-text-header roboto-n" 
              :class="{ active: classActive == 'homeScroll' }"
              @click="scrollTo('homeScroll')"
            >
             Home
            </span>

            <span 
              class="btn-text-header roboto-n"
              :class="{ active: classActive == 'sobreScroll' }"
              @click="scrollTo('sobreScroll')"
            >
             Sobre nós
            </span>

            <span 
              class="btn-text-header roboto-n"
              :class="{ active: classActive == 'guiaScroll' }"
              @click="scrollTo('guiaScroll')"
            >
             Serviços
            </span>

            <span 
              class="btn-text-header roboto-n"
              :class="{ active: classActive == 'cotacaoScroll' }"
              @click="scrollTo('cotacaoScroll')"
            >
             Cotações
            </span>

            <span 
              class="btn-text-header roboto-n"
              @click="$bvModal.show('login2')"
              v-if="checkIsEmpty(token) && checkIsEmpty(dadosUsuario)"
            >
              Entrar
            </span>
          </b-col>
        </b-row>
      </div>
    </div>
    
    <b-modal
      v-if="checkIsEmpty(token)"
      title="Acesse sua conta"
      size="md"
      id="login2"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div
        class="row d-flex flex-row align-items-center justify-content-center"
      >
        <form class="col-12 col-md-12">
          <div class="form-row">
            <div class="col-12 mb-2">
              <!-- <label for="email" class="font-weight-bold">Email</label> -->
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="field-mail">E-mail</span>
                </div>
                  <input
                    type="text"
                    id="setEmail"
                    name="email"
                    aria-describedby="field-mail"
                    v-model="login"
                    @keyup.enter="balconista ? searchClerk() : logar2()"
                    class="form-control addEmail"
                    placeholder="E-mail, CPF ou CNPJ"
                  />
              </div>
            </div>

            <div class="col-12 mb-2">
              <InputPassword
                placeholder="Digite a sua senha"
                :value.sync="senha"
                @keyup.native.enter="balconista ? searchClerk() : logar2()"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="c-orange c-pointer fs-16 text-left">
                <span class="c-orange">
                  <input type="checkbox" v-model="balconista"> Sou colaborador
                </span>
              </div>
            </div>
            <div class="col-6">
              <div class="c-orange c-pointer fs-16 text-right">
                <span class="c-orange c-pointer" @click="rescueModal()">
                  Esqueceu a senha?
                </span>
              </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <button
              type="button"
              style="width: 250px;"
              class="btn bg-orange text-white"
              @click="balconista ? searchClerk() : logar2()"
            >
              <i class="fas fa-sign-in-alt mr-2"></i>
              Entrar
            </button>
          </div>
        </form>
        <div class="col-12 col-md-12">
          <p class="fs-22 text-center font-weight-bold text-uppercase mt-3">
            Ou
          </p>
        </div>
        <div class="col-12 col-md-12">
          <div class="my-3 text-center">
            <div class="w-100">
              <div class="">
                <GoogleLoginButton />
              </div>
              <div class="social-login-buttons my-3">
                <FacebookLoginButton />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn text-center mt-4 fs-22">
        Não possui cadastro ainda?
        <button
          style="margin-top: -10px"
          class="c-orange c-orange-hover text-decoration-none btn fs-18"
          @click="hideAndRead()"
        >
          Cadastre-se
        </button>
      </div>
    </b-modal>

    <b-modal
      title="Recuperar senha"
      size="lg"
      id="rescuePasswrd"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <modal-email></modal-email>
    </b-modal>

    <b-modal
      title="Selecione uma empresa"
      size="md"
      id="selectAcconts"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12" v-for="(item, i) in acconts" :key="i">
          <div 
            :class="shopkeeper == item.usuario_id ? 'alert alert-success cursor-pointer' : 'alert alert-secondary cursor-pointer'"
            role="alert"
            @click="shopkeeper = item.usuario_id"
          >
            {{item.nome_fantasia}}
          </div>
        </div>

        <div class="col-12 mt-4 text-center">
          <button
            class="btn btn-success pr-4 pl-4"
            @click="logar2()"
          >
            Acessar
          </button>
        </div>
      </div>
    </b-modal>

    <b-row no-gutters v-if="windowWidth < 1000 && $route.name == 'home'">
      <b-col cols="12">
        <b-navbar toggleable fixed>
          <div class="painelButton mt-2">
            <b-button class="ml-3" v-b-toggle.painelHome variant="outilene" style="color:#FFF">
              <i class="fas fa-bars fs-30"></i> 
            </b-button>
          </div>
          <b-sidebar
            v-model="painelHome"
            id="painelHome" 
            shadow 
            width="400px"
            :no-close-on-route-change="windowWidth > 1000 ? true : false"
          >
            <b-navbar-brand>
              <div class="brandAlign">
                <img
                  src="@/assets/img/Logo Novo ConstrUp.png"
                  alt="Logo Constr Up"
                  width="180"
                />
              </div>
            </b-navbar-brand>
            <b-navbar-nav>
              <div class="p-2 bg-gray-1 pl-3">

                <span
                  v-if="!checkIsEmpty(token)"
                  class="c-orange d-flex align-items-center shadow border-radius bg-white p-1 no-text-decoration col-md-12 col-lg-6 col-xl-6 mt-2"
                  @click="goToPages()"
                >
                  <div class="d-flex w-100 col-12 align-items-center">
                    <i class="fas fa-list-alt menu-icon d-flex fs-18 mr-2"></i>
                    <span class="c-black fs-15">
                      Meu painel
                    </span>
                  </div>
                </span>

                <span
                  v-if="$route.name == 'home'"
                  class="c-orange d-flex align-items-center shadow border-radius bg-white p-1 no-text-decoration col-md-12 col-lg-6 col-xl-6 mt-2"
                  @click="scrollTo('homeScroll')"
                >
                  <div class="d-flex w-100 col-12 align-items-center">
                    <i class="fas fa-home menu-icon d-flex fs-18 mr-2"></i>
                    <span class="c-black fs-15">
                      Home
                    </span>
                  </div>
                </span>

                <span
                  v-if="$route.name == 'home'"
                  class="c-orange d-flex align-items-center shadow border-radius bg-white p-1 no-text-decoration col-md-12 col-lg-6 col-xl-6 mt-2"
                  @click="scrollTo('sobreScroll')"
                >
                  <div class="d-flex w-100 col-12 align-items-center">
                    <i class="fas fa-building menu-icon d-flex fs-18 mr-2"></i>
                    <span class="c-black fs-15">
                      Sobre nós
                    </span>
                  </div>
                </span>

                <span
                  v-if="$route.name == 'home'"
                  class="c-orange d-flex align-items-center shadow border-radius bg-white p-1 no-text-decoration col-md-12 col-lg-6 col-xl-6 mt-2"
                  @click="scrollTo('guiaScroll')"
                >
                  <div class="d-flex w-100 col-12 align-items-center">
                    <i class="fas fa-users-cog menu-icon d-flex fs-18 mr-2"></i>
                    <span class="c-black fs-15">
                      Serviços
                    </span>
                  </div>
                </span>

                <span
                  v-if="$route.name == 'home'"
                  class="c-orange d-flex align-items-center shadow border-radius bg-white p-1 no-text-decoration col-md-12 col-lg-6 col-xl-6 mt-2"
                  @click="scrollTo('cotacaoScroll')"
                >
                  <div class="d-flex w-100 col-12 align-items-center">
                    <i class="fas fa-file-alt menu-icon d-flex fs-18 mr-2"></i>
                    <span class="c-black fs-15">
                      Cotações
                    </span>
                  </div>
                </span>

                <BasicItem
                  v-if="!checkIsEmpty(token)"
                  :text="'Sair'"
                  :icon="'fas fa-power-off'"
                  :routeName="'sair'"
                />

                <button
                  v-if="checkIsEmpty(token) && checkIsEmpty(dadosUsuario)"
                  class="btn bg-orange btn-block mt-4 mb-4"
                  @click="$bvModal.show('login2')"
                >
                  <i
                    class="fas fa-sign-in-alt text-white"
                    aria-hidden="true"
                  ></i>
                  <span class="text-white ml-2">Entrar</span>
                </button>
              </div>
            </b-navbar-nav>
          </b-sidebar>
        </b-navbar>
      </b-col>
    </b-row>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { setTimeout } from 'timers';
import FacebookLoginButton from './FacebookLoginButton.vue';
import GoogleLoginButton from './GoogleLoginButton.vue';
import GeneralSearchBar from './GeneralSearchBar.vue';
import UserTypes from '../enums/UserTypes';
import modal from '../mixins/modal';
import InputPassword from './Inputs/InputPassword.vue';
import TextAccess from './Register/TextAccess.vue';
import TextBasicData from './Register/TextBasicData.vue';
import TermsAndConditions from './TermsAndConditions.vue';
import PrivacyPolicy from './PrivacyPolicy.vue';
import ModalFirstAcess from '../views/ModalFirstAcess.vue';
import ModalEmail from '../components/ModalEmail.vue';
import BasicItem from './Menu/BasicItem.vue';

export default {
  name: 'header-login',
  mixins: [modal],
  data: () => ({
    balconista: false,
    shopkeeper: null,
    acconts: null,
    classActive: 'homeScroll',
    windowWidth: window.innerWidth,
    painelHome: false,
    login: null,
    senha: null,
    // scroll: true,
    tokenCot: '8 f g x',
    infoRecuperar: null,
    provider: null,
    UserTypes,
    tipoUsuario: 0,
    afiliadoId: 0,
    partnerId: '',
    typePerson: '',
    recuperar: false,
    Fields: {
      paymentPlan: '',
      cep: '',
      endereco: '',
      bairro: '',
      cidade_id: null,
    },
  }),
  beforeMount() {
    this.$store.dispatch('loadToken');
  },
  components: {
    GeneralSearchBar,
    FacebookLoginButton,
    GoogleLoginButton,
    InputPassword,
    TextBasicData,
    TextAccess,
    PrivacyPolicy,
    TermsAndConditions,
    ModalFirstAcess,
    ModalEmail,
    BasicItem,
  },
  computed: {
    ...mapGetters(['getToken', 'getTipoNotification', 'getNotification']),
    ...mapState(['token', 'dadosUsuario']),
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.widthWindow();
    if (this.$route.query.recuperar == 'true') {
      this.recuperar = true;
      this.$bvModal.show('rescuePasswrd');
    }
    this.checkRoute();
  },

  methods: {
    checkRoute() {
      if(this.$route.name === 'fazer-nova-cotacao'){
        return true
      }
      return false
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 1000) this.painelHome = true;
    },
    widthWindow() {
      if (this.windowWidth > 1000) this.painelHome = true;
    },
    scrollTo(sectionId) {
      this.painelHome = false;
      this.classActive = sectionId;
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    modalEmail() {
      this.$bvModal.show('rescuePasswrd');
      this.$bvModal.hide('login2');
    },

    hideAndRead() {
      this.$bvModal.hide('login2');
      this.$router.push({ name: 'cadastro' });
    },
    usersTypesValidForRegistration() {
      return this.tipoUsuarios.filter(
        (userType) =>
          userType.id !== this.UserTypes.ADMINISTRATOR &&
          userType.id !== this.UserTypes.EDITOR &&
          // && userType.id !== this.UserTypes.AFFILIATED
          userType.id !== this.UserTypes.REPRESENTATIVE &&
          userType.id !== this.UserTypes.GUEST &&
          userType.id !== this.UserTypes.PARTNER
      );
    },
    checkPartner(type_id) {
      if (type_id == 9) return true;
      return false;
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    logar() {
      const data = {
        email: this.login,
        password: this.senha,
      };
      if (this.data !== null) {
      }
      if (data.email !== null && data.password !== null) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('loadLogin', data)
          .then(() => {
            if (this.getTipoNotification === 1) {
              this.aviso(this.getNotification, 'success');
            } else if (this.getTipoNotification === 3) {
              this.aviso(this.getNotification, 'danger');
            }
            if (this.dadosUsuario !== null) {
              this.$bvModal.hide('login');

              if (this.$route.name === 'fazer-nova-cotacao') {
                this.showModal('uteis');
              } else if (this.$route.name === 'guia-profissionais-single') {
                this.$router.push(this.$route.fullPath);
              } else if (this.dadosUsuario.tipo_usuario === 'Cliente') {
                this.$router.push({ name: 'cliente-meus-dados' });
              } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
                this.$router.push({ name: 'lojista-meus-dados' });
              } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
                this.$router.push({ name: 'profissional-meu-perfil' });
              } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
                this.$router.push({ name: 'representante-meus-dados' });
              } else if (this.dadosUsuario.tipo_usuario === 'Editor') {
                this.$router.push({ name: 'editor-meus-dados' });
              } else if (this.dadosUsuario.tipo_usuario === 'Administrador') {
                this.$router.push({ name: 'administrador-meus-dados' });
              } else if (
                this.dadosUsuario.tipo_usuario_id === UserTypes.AFFILIATE
              ) {
                this.$router.push({ name: 'afiliado-meus-dados' });
              } else if (
                this.dadosUsuario.tipo_usuario_id === UserTypes.PARTNER
              ) {
                this.$router.push({ name: 'parceiro-meus-dados' });
              }
            }
          })

          .catch((error) => {
            this.aviso(error.response.data.message, 'danger');
          })
          .finally(() => this.$store.dispatch('endLoader'));
      } else {
        this.aviso(
          'É necessário que você digite algo nos dois campos!',
          'warning'
        );
      }
    },
    searchClerk() {
      if(this.login == null || this.senha == null) {
        this.aviso('Informe o E-mail e senha para fazer login!', 'warning');
        return;
      }

      const data = {
        email: this.login,
        password: this.senha,
        balconista: this.balconista
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch('searchClerks', data)
        .then((response) => {
          if(response.data.acconts) {
            if(response.data.first) {
              this.shopkeeper = response.data.data[0].usuario_id;

              this.logar2();
            } else {
              this.acconts = response.data.data;
              this.$store.dispatch('endLoader');
              this.$bvModal.show('selectAcconts');
            }
          } else {
            this.aviso('Não foi encontrada nenhuma conta!', 'danger');
            this.$store.dispatch('endLoader')
          }
          console.log(response);
        })
        .catch((error) => {
          this.aviso('Erro ao tentar fazer login', 'danger');
        });
    },
    logar2() {
      if(this.login == null || this.senha == null) {
        this.aviso('Informe o E-mail e senha para fazer login!', 'warning');
        return;
      }

      if(this.balconista && this.shopkeeper == null) {
        this.aviso('Informe uma conta para fazer login!', 'warning');
        return;
      }

      this.$bvModal.hide('selectAcconts');

      const data = {
        email: this.login,
        password: this.senha,
        balconista: this.balconista,
        shopkeeper: this.shopkeeper
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch('loadLogin', data)
        .then(() => {
          this.shopkeeper = null;

          if (this.getTipoNotification === 1) {
            this.aviso(this.getNotification, 'success');
          } else if (this.getTipoNotification === 3) {
            this.aviso(this.getNotification, 'danger');
          }
          if (this.dadosUsuario !== null) {
            this.$bvModal.hide('login2');

            if (this.$route.name === 'fazer-nova-cotacao') {
              const data = JSON.parse(localStorage.getItem('quote'));
              data.usuario = this.dadosUsuario.id;
              this.sendQuote(data);
            } else if (this.$route.name === 'guia-profissionais-single') {
              this.$router.push(this.$route.fullPath);
            } else if (this.dadosUsuario.tipo_usuario === 'Cliente') {
              this.$router.push({ name: 'cliente-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
              this.$router.push({ name: 'lojista-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
              this.$router.push({ name: 'profissional-meu-perfil' });
            } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
              this.$router.push({ name: 'representante-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Editor') {
              this.$router.push({ name: 'editor-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Administrador') {
              this.$router.push({ name: 'administrador-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.AFFILIATE) {
              this.$router.push({ name: 'afiliado-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.PARTNER) {
              this.$router.push({ name: 'parceiro-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.BALCONISTA) {
              this.$router.push({ name: 'balconista-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.GERENTECONTA) {
              this.$router.push({ name: 'gerente-meus-dados' });
            }
          }
        })
        .catch((error) => {
          this.aviso(error.response.data.message, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    sendQuote(data) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('insertCotacao', data)
        .then(() => {
          localStorage.setItem('quote', null);
          this.$store.dispatch('endLoader');
          this.aviso('Seu orçamento foi realizado com sucesso!', 'success');
          setTimeout(() => {
            if (this.dadosUsuario.tipo_usuario === 'Cliente') {
              this.$router.push({ name: 'cliente-solicitados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
              this.$router.push({ name: 'lojista-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
              this.$router.push({ name: 'profissional-meu-perfil' });
            } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
              this.$router.push({ name: 'representante-meus-dados' });
            }
          }, 1000);
        })
        .catch(() => {});
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    toggleModal() {
      this.$refs['my-modal'].toggle('#toggle-btn');
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    goToPages() {
      if (!this.checkIsEmpty(this.dadosUsuario)) {
        if (this.dadosUsuario.tipo_usuario === 'Cliente') {
          this.$router.push({ name: 'cliente-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
          this.$router.push({ name: 'lojista-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
          this.$router.push({ name: 'profissional-meu-perfil' });
        } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
          this.$router.push({ name: 'representante-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario === 'Administrador') {
          this.$router.push({ name: 'administrador-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.AFFILIATE) {
          this.$router.push({ name: 'afiliado-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.PARTNER) {
          this.$router.push({ name: 'parceiro-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.BALCONISTA) {
          this.$router.push({ name: 'balconista-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario_id === UserTypes.GERENTECONTA) {
          this.$router.push({ name: 'gerente-meus-dados' });
        }
      } else {
        this.$router.push({ name: 'cadastro' });
      }
    },
    showModal(modalId) {
      this.$bvModal.show(modalId);
    },
    rescueModal() {
      this.$bvModal.show('rescuePasswrd');
      this.$bvModal.hide('login2');
    },
    recuperarSenha() {
      const self = this;

      if (!this.checkIsEmpty(this.infoRecuperar)) {
        this.$store
          .dispatch('sendMailRecuperarSenha', this.infoRecuperar)
          .then(() => {
            this.$store.dispatch('startLoader');
            setTimeout(() => {
              self.$store.dispatch('endLoader');
              self.aviso('Email enviado com sucesso!', 'success');
            }, 1500);
          })
          .catch(() => {
            this.aviso(
              'Houve um problema em enviar seu e-mail, tente novamente em 5 minutos!',
              'danger'
            );
          });
      } else {
        this.aviso('É necessario escrever seu e-mail!', 'warning');
      }
    },
    openUserTypeModal(provider) {
      this.$bvModal.show('userType');
      this.provider = provider;
    },
    hideAllModals() {
      this.$bvModal.hide('login');
      this.$bvModal.hide('userType');
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.15.4/css/all.css';
@import '../custom/css/media-query.css';
.btn-warning {
  border: none !important;
}

.border-radius {
  border-radius: 8px;
}

.btn-text-header {
  color: #FFF;
  padding: 10px 25px;
  cursor: pointer;
  font-weight: 100 !important;
  letter-spacing: 2px;
  margin-left: 10px;
  transition: background 0.5s ease, transform 0.5s ease;
  display: inline-block;
  border-radius: 30px;
}

.btn-text-header:hover {
  background: #ff7f00;
  border-radius: 30px;
  transform: scale(1.1);
}

.zoom-on-hover {
  transition: transform 0.1s ease-in-out, background 0.1s ease-in-out;
}

.zoom-on-hover:hover {
  transform: scale(1.1);
}

.btn-text-header:hover {
  background: #ff7f00;
  border-radius: 30px;
}

.btn-text-header.active {
  background: #ff7f00;
  border-radius: 30px;
}

.social-login-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 1 0 auto;
}

.grey-border {
  border: 1.4px solid var(--grey);
  border-radius: 8px;
}

.icon {
  width: 24px;
}

.headerFixed {
  position: fixed;
  top: 0;
  z-index: 8;
  width: 100vw;
  height: 185px;
  background-image: url('../assets/img/header.png');
  background-repeat: no-repeat;
}
.itemDisplayMobile {
  display: none;
}
@media screen and (min-width: 1000px) {
  .menuView {
    margin-left: 415px;
    margin-top: 60px;
    overflow-x: hidden;
  }
}
@media screen and (max-width: 1000px) {
.itemDisplay {
  display: none;
}
.img-fluid-mobile {
  width: 30%;
}
.itemDisplayMobile {
  display: block;
}
.headerFixed {
  height: 100px;
}
.headerFixed {
  position: fixed;
  top: 0;
  z-index: 8;
  width: 100vw;
  height: 85px;
  background-image: none;
}
}
</style>

